import React from 'react';
import styled from 'styled-components';
import Typography from '../Typography';
import { Checkbox } from '@quikr/ui';

const Wrapper = styled(Typography)`
  padding: 10px 0px 10px;
`;

const Label = styled.label`
  color: ${({ theme }) => theme.colors.TextAlpha};
  margin-right: 10px;
  span {
    color: ${({ theme }) => theme.colors.Secondary};
    left: 5px;
  }
`;

const WhatsAppOpt = props => {
  return (
    <Wrapper className="dFA jcC" tagName="div" modifiers="bt2">
      <Checkbox {...props} />
      <Label className="dFA">
        I agree to get job updates from QuikrJobs on <span className="pR">WhatsApp</span>
      </Label>
    </Wrapper>
  );
};

export default WhatsAppOpt;
